import React, {Component} from "react";
import "./styles.css"

import {upsellEcData} from './upsell-Ec-Data';
import UpsellEcHeader from './upsell-Ec-Header';
import UpsellEcContent from './upsell-Ec-Content';
import UpsellEcFooter from './upsell-Ec-Footer';
import { connect } from 'react-redux';
import {
  withRouter
} from 'react-router-dom';

class UpsellEcComponent extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillMount(){
    if(typeof this.props.togglePack === 'undefined')
      this.props.history.push(`/contrats/${this.props.match.params.name}/${this.props.match.params.id}/paiement`)
      document.getElementById("app-container").classList.add("fullWidth");
      document.getElementById("main-nav").classList.add("delete-margin");
  }

  componentWillUnmount() {
    document.getElementById("app-container").classList.remove('fullWidth')
    document.getElementById("main-nav").classList.remove('delete-margin')
  }

  render(){
    const {header,content,footer,card} = upsellEcData
    return(
      <main className="upsellEcWrapper">
        <UpsellEcHeader header={header} card={card} />
        <UpsellEcContent content={content} />
        <UpsellEcFooter footer={footer} card={card} />
      </main>
    )
  }
}

const mapStateToProps = state => ({
  togglePack: state.checkout_operations.togglepack
});

const UpsellEc = withRouter(connect(mapStateToProps, null)(UpsellEcComponent));

export default UpsellEc;



// WEBPACK FOOTER //
// ./src/components/buy/Upsell-EC/upsell-Ec.js